import { Component, ElementRef, ViewChild } from '@angular/core';
import { AlertController, NavController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { HelperProvider } from '../../providers/helper-service';
import { ArtstammScan } from '../../providers/rest-server/data/ArtstammScan';
import { ServerProvider } from '../../providers/rest-server/server-provider';
import { ScanProvider } from '../../providers/scan-provider/scan-provider';

@Component({
    selector: 'page-regal-kontrolle',
    templateUrl: 'regal-kontrolle.html'
})
export class RegalKontrollePage {

    public scans: Array<ArtstammScan> = [];
    public start = true;
    public barcode: string;

    @ViewChild('inputBarcode') inputBarcode: ElementRef;

    constructor(
        public navCtrl: NavController,
        private scanProvider: ScanProvider,
        private alertCtrl: AlertController,
        private server: ServerProvider,
        private helper: HelperProvider,
    ) {
    }

    public addInput(): void {
        if (this.barcode) {
            this.checkScan(this.barcode);
        }
    }

    public scan(): void {
        this.scanProvider.scan().subscribe(barcode => {
            if (barcode) {
                this.checkScan(barcode);
            }
        }, err => {
            let alert = this.alertCtrl.create({
                title: 'Fehler beim Scan',
                message: err,
                buttons: ['Ok']
            });
            alert.present();
        });
    }

    public checkScan(barcode: string): void {
        this.barcode = null;

        if (this.start) {
            console.log('Prüfe Startetikett: ' + barcode);
            this.helper.wrapLoading(this.server.scanLagerplatzStartEtikett(barcode)).subscribe(lagerplatzStartEtikettResult => {
                this.start = false;
                this.scans = [];
                this.helper.toast('Startetikett erfolgreich gescannt.');
                this.focusBarcode();
            });
        } else {
            console.log('Prüfe EAN: ' + barcode);
            this.helper.wrapLoading(this.server.scanArtikel(barcode)).subscribe(scanArtikelResult => {
                if (scanArtikelResult.artstammScan != null) {
                    const artstammScan = <ArtstammScan>scanArtikelResult.artstammScan;

                    for (let i = 0; i < this.scans.length; i++) {
                        let scan = this.scans[i];
                        if (scan.artstamm.eancode === artstammScan.artstamm.eancode) {
                            this.scans.splice(i, 1);
                            break;
                        }
                    }

                    this.scans.unshift(artstammScan);

                    this.helper.toast(`Artikel ${artstammScan.artstamm.cartikelnummer} hinzugefügt`);
                    this.focusBarcode();
                }
                if (scanArtikelResult.warnmeldung) {
                    let alert = this.alertCtrl.create({
                        title: 'Result',
                        message: scanArtikelResult.warnmeldung,
                        buttons: ['Ok']
                    });
                    alert.present();
                }
                if (scanArtikelResult.endetikett) {
                    this.finish();
                }
            });
        }
    }

    private focusBarcode() {
        // setTimeout(() => {
        //     (<any>this.inputBarcode).setFocus();
        // }, 500);
    }

    public delete(artstammScan: ArtstammScan): void {
        const idx = this.scans.indexOf(artstammScan, 0);
        if (idx >= 0) {
            this.helper.alertConfirm('', `Den Artikel mit EAN ${artstammScan.artstamm.eancode} entfernen?`).subscribe(ok => {
                if (ok) {
                    this.scans.splice(idx, 1);
                }
            });
        }
    }

    public finish(): void {
        this.helper.alertConfirm('', `Artikel-Zuordnung beenden und absenden?`).subscribe(ok => {
            if (ok) {
                const idartstammList = this.scans.map(x => x.artstamm.idartstamm);
                this.helper.wrapLoading(this.server.scanErgebnis(idartstammList)).subscribe(() => {
                    this.start = true;
                    this.scans = [];
                    this.helper.toast(`Regal-Scan erfolgreich abgeschlossen.`);
                    this.focusBarcode();
                });
            }
        });
    }

    public abort(): void {
        const obs =
            this.scans.length > 0 ?
                this.helper.alertConfirm('', `Alle bereits gescannten Zuordnungen verwerfen.`) :
                Observable.of(true);

        obs.subscribe(ok => {
            if (ok) {
                this.start = true;
                this.scans = [];
                this.helper.toast(`Regal-Scan beendet.`);
                this.focusBarcode();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/regal-kontrolle/regal-kontrolle.ts